import { toast } from "react-toastify";

const success = (message: string) => {
  toast.success(message, { toastId: message });
};

const error = (message: string) => {
  toast.error(message, { toastId: message });
};

const warning = (message: string) => {
  toast.warning(message, { toastId: message });
};

const info = (message: string) => {
  toast.info(message, { toastId: message });
};

export const tMsg = {
  success,
  error,
  warning,
  info,
};
